import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-no-data-available',
    templateUrl: './no-data-available.component.html',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class NoDataAvailableComponent {

  @Input() hasData;

  constructor() { }

}
